<template>
  <div class="discussion container-fluid">
    <div class="main-content" v-if="!isUserGroupAdmin">
      <report-filter-bar @selectedGroupObj="setGroupCourseObj" @selectedCohortObj="setCohortObj" v-bind:showExport="showExportButton" @isExportBtnClicked="exportCSV" @isViewBtnClicked="updateViewBtnClickedFlag"></report-filter-bar>
      <!-- <report-group-filter-bar @selectedGroupObj="setGroupObj" v-bind:showExport="showExportButton" @isExportBtnClicked="exportCSV" @isViewBtnClicked="updateViewBtnClickedFlag"></report-group-filter-bar> -->
      <hr width="97%" size="10px">
      <div class="row margin-Top-2Perc">
        <div class="col-md-11 col-lg-11 width margin-left-2Perc">
          <sortable-list v-if="showDiscussionList" v-bind:responseObj="getDiscussionRespArrResp" v-bind:sortableColumnName="sortColumnNames" v-bind:columnNameToShow="columnNameToShow" v-bind:linkColumnName="linkColumnNames" v-bind:selectedsubOption="1"></sortable-list>
        </div>
      </div>
      <div class="row margin-Top-3Perc">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <Copyright-Element class="footer"></Copyright-Element>
        </div>
      </div>
      <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
      <!-- Show Spinner -->
      <div class="animationload" v-show="showSpinner">
        <div class="osahanloading"></div>
      </div>
    </div>
    <loader></loader>
    <error-page v-if="isUserGroupAdmin"></error-page>        
  </div>  
</template>

<script>
import ReportFilterBar from '@/components/ReportFilterBar'
// import ReportGroupFilterBar from '@/components/ReportGroupFilterBar'
import list from '@/pages/SortableList'
import CopyrightElement from '@/components/CopyrightElement'
import { constants } from '@/utils/constants'
import { reportService } from '@/server-util/report-service'
import AlertBox from '@/components/AlertOverlay'
import csvHelper from '@/utils/csv-helper'
import ErrorPage from '@/pages/Error'
import Loader from '@/components/dashboard/Loader'
import isString from 'lodash/isString'
import { participantService } from '@/server-util/participant-service'
export default {
  created: function () {
    this.bindColumnsNameAndAlias()
    this.checkUserErrorStatus()
  },
  data: function () {
    return {
      /*
      selectedGroupCourseObj: null,
      selectedCohortObj: null,
      */
      selectedGroupObj: null,
      showExportButton: true,
      showAlertDialog: false,
      errorMsg: '',
      showSpinner: false,
      discussionRespArr: [],
      showDiscussionList: false,
      sortColumnNames: ['FullName', 'UserName', 'Email', 'LessonTitle', 'RDTitle', 'RDType', 'RDQuestion', 'Comments', 'Likes', 'TextResponse', 'SubmitTSString'],
      columnAlias: ['Name', 'Username', 'Email', 'Lesson', 'Reflection Title', 'Reflection Type', 'Reflection Question', '# of Comments', '# of Likes', 'User Response', 'Submitted Date'],
      columnRespKey: ['FullName', 'UserName', 'Email', 'LessonTitle', 'RDTitle', 'RDType', 'RDQuestion', 'Comments', 'Likes', 'TextResponse', 'SubmitTSString'],
      columnNameToShow: [],
      linkColumnNames: ['Comments', 'Likes'],
      isExportBtnClicked: false,
      isViewBtnClicked: false
    }
  },
  components: {
    'report-filter-bar': ReportFilterBar,
    'Copyright-Element': CopyrightElement,
    'sortable-list': list,
    'alert-box': AlertBox,
    'error-page': ErrorPage,
    'loader': Loader
  },
  methods: {
    checkUserErrorStatus: function () {
      var storeObj = this.$store
      if (storeObj.state.access_token !== undefined && storeObj.state.access_token !== null && storeObj.state.access_token !== '') {
        participantService
          .getUserErrorStatus(
            storeObj.state.access_token
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              const jsonObj = responseObj.data
              this.checkAndShowAlert(jsonObj)
            }
          }, errorObj => {
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
            console.log('getUserErrorStatus Error :::' + this.errorMsg)
          })
      } else {
        console.log(
          'Access Token or required data is NULL hence declined LOADING GET ERROR INFO'
        )
      }
    },
    checkAndShowAlert: function (jsonObj) {
      if (jsonObj !== undefined && jsonObj !== 'undefined' && jsonObj !== null && jsonObj !== 'null' && jsonObj !== '') {
        const isLoggedOut = jsonObj.IsAdminLoggedOut
        const profileError = jsonObj.ProfileError
        if (isLoggedOut) {
          this.showAlertDialog = true
          this.errorMsg = constants.Logged_Out_From_Another_Platform_Error_Msg
        } else if (profileError === constants.Change_Password_Error_Profile) {
          this.showAlertDialog = true
          this.errorMsg = constants.Change_Password_Alert_Msg
        }
      }
    },
    peformCleanUpOperationOnSignOut: function () {
      var store = this.$store
      var cookies = this.$cookies
      cookies.remove(constants.LOGIN_COOKIE_KEY)
      cookies.remove(constants.LOGIN_USER_COOKIE)
      store.state.isUserProfileLoaded = false
      localStorage.removeItem(constants.LOGIN_USER_COOKIE)
      localStorage.setItem('selectedMenu', 0)
      localStorage.setItem('selectedSubMenu', 0)
      localStorage.clear()
      this.$store.state.curr_user = null
      this.$store.commit('resetState')
      this.$router.push('/')
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
      switch (this.errorMsg) {
        case constants.Logged_Out_From_Another_Platform_Error_Msg:
          this.peformCleanUpOperationOnSignOut()
          break
        case constants.Change_Password_Alert_Msg:
          localStorage.setItem('selectedMenu', constants.MenuOptionsEnum.Settings)
          localStorage.setItem('selectedSubMenu', constants.SubMenuOptionsEnum.EditProfile)
          this.$router.push('/profile?OpenPopUp=true')
          break
      }
    },
    setGroupCourseObj (value) {
      // AK: When user selected particular group object then update it in parent file too
      this.selectedGroupCourseObj = value
    },
    setCohortObj (value) {
      // AK: When user selected particular cohort object then update it in parent file too
      this.selectedCohortObj = value
      // this.isViewBtnClicked = true
      // this.getDiscussionReport()
    },
    updateViewBtnClickedFlag (value) {
      this.isViewBtnClicked = value
      if (value) {
        this.bindColumnsNameAndAlias()
        this.getDiscussionReport()
      }
    },
    exportCSV (value) {
      this.isExportBtnClicked = value
      if (value) {
        // this.bindColumnsNameAndAlias()
        // this.getDiscussionReport()
        this.getDiscussionReportForCSV()
      }
    },
    bindColumnsNameAndAlias: function () {
      this.columnNameToShow = []
      for (var i = 0; i < this.columnRespKey.length; i++) {
        var obj = {
          ColumnName: this.columnRespKey[i],
          ColumnAlias: this.columnAlias[i]
        }
        this.columnNameToShow.push(obj)
      }
      // console.log('Column And alias Name Obj >>>> ' + JSON.stringify(this.columnNameToShow))
    },
    /*
    setGroupObj (value) {
      // AK: When user selected particular Group object then update it in parent file too
      this.selectedGroupObj = value
    }, */
    getDiscussionReport: function () {
      var storeObj = this.$store
      var _this = this
      if (this.selectedCohortObj.CohortId !== null || this.selectedCohortObj.CohortId !== undefined || this.selectedCohortObj.CohortId !== '') {
        // this.showSpinner = true
        this.$store.state.isLoading = true
        reportService.getDiscussionReportData(storeObj.state.access_token, _this.selectedCohortObj.CohortId).then(
          responseObj => {
            _this.$store.state.isLoading = false
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Hide Spinner after recieving group list
              _this.$store.state.isLoading = false
              if (isString(responseObj.data)) {
                // AK: Remove non-printable and other non-valid JSON chars
                const jsonData = responseObj.data.replace(/[\u0000-\u0019]+/g, '')
                _this.discussionRespArr = JSON.parse(jsonData)
              } else {
                _this.discussionRespArr = responseObj.data
              }
              if (parseInt(_this.discussionRespArr.length) === 0) {
                this.showAlertDialog = true
                this.errorMsg = 'No report found for \'' + this.selectedCohortObj.CohortName + '\' cohort.'
                this.showDiscussionList = false
              } else {
                this.processAndExecuteSelectedOperation()
              }
            } else {
              // AK: Hide Spinner
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
              this.showAlertDialog = true
              this.errorMsg =
                'Oops! Something went wrong. Please try again.'
            }
          },
          errorObj => {
            // AK: Hide Spinner
            // _this.showSpinner = false
            _this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          }
        )
      } else {
        console.log('COHORT ID is NULL hence declined LOADING Cohort LIST')
      }
    },
    getDiscussionReportForCSV: function () {
      var storeObj = this.$store
      var _this = this
      if (this.selectedCohortObj.CohortId !== null || this.selectedCohortObj.CohortId !== undefined || this.selectedCohortObj.CohortId !== '') {
        // this.showSpinner = true
        this.$store.state.isLoading = true
        reportService.getDiscussionReportDataForCSV(storeObj.state.access_token, _this.selectedCohortObj.CohortId).then(
          responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Hide Spinner
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
              return csvHelper.exportFromServerData(responseObj.data, 'DiscussionReport(' + this.selectedCohortObj.CohortName + ')')
            } else {
              // AK: Hide Spinner
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
              this.showAlertDialog = true
              this.errorMsg =
                'Oops! Something went wrong. Please try again.'
            }
          },
          errorObj => {
            // AK: Hide Spinner
            // _this.showSpinner = false
            _this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          }
        )
      } else {
        console.log('COHORT ID is NULL hence declined LOADING Cohort LIST')
      }
    },
    processAndExecuteSelectedOperation: function () {
      if ((!this.isExportBtnClicked) && this.isViewBtnClicked) {
        // AK: If export btn not clicked and list is shown previously then show list only
        this.showDiscussionList = true
      } else if (this.isExportBtnClicked && (!this.isViewBtnClicked)) {
        // AK: If user directly clicked on export button without clicking view first then export data
        this.exportData()
      } else if (this.isExportBtnClicked && this.isViewBtnClicked) {
        // AK: If user performed both operations then performed both operations
        this.showDiscussionList = true
        this.exportData()
      }
    },
    exportData: function () {
      return csvHelper.export(this.getDiscussionRespArrResp, this.columnRespKey, this.columnAlias, 'DiscussionReport(' + this.selectedCohortObj.CohortName + ')')
    }
  },
  computed: {
    getDiscussionRespArrResp: {
      get: function () {
        return this.discussionRespArr
      }
    },
    isUserGroupAdmin: {
      get: function () {
        var userObj = this.$store.state.curr_user
        if (parseInt(userObj.AccountType) === parseInt(constants.UserAccountType.Group_Admin)) {
          return true
        } else {
          return false
        }
      }
    }
  },
  name: 'discussion'
}
</script>

<style scoped>
.discussion {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.width {
  width: 100% !important;
}
.width1 {
  width: 97.3% !important;
}
.margin-left-0point2Perc {
  margin-left: 0.2% !important;
}
.margin-left-1point6Perc {
  margin-left: 1.6% !important;
}
.margin-Top-2Perc {
  margin-top: 2%;
}
.font-size-20px
{
  font-size:20px;
}
.margin-Top-1Perc {
  margin-top: 1%;
}
.black-border {
  border: 1px solid #aaa;
}
.custom-btn {
  padding: 5px 12px !important;
}
.padding-Left-30px {
  padding-left: 3% !important;
}
.white-BG {
  background-color: #ffffff;
}
.padding-Left-0px {
  padding-left: 0px !important;
}
.padding-right-0px {
  padding-right: 0px !important;
}
.margin-Top-3Perc{
  margin-top: 3% !important;
}
.margin-Top-5Perc{
  margin-top: 5% !important;
}
.margin-left-1Perc{
  margin-left: 1% !important;
}
.padding-bottom-0Perc{
  padding-bottom: 0px; 
}
/* Using Only for footer */
.footer{
  /* position: fixed; */
    left: 38px !important;
    bottom: 0 !important;
    width: 100% !important;
    /* background-color: red; */
    /* color: white; */
    text-align: center !important;
    margin-bottom: 1% !important;
    font-size: 12px !important;
}
.margin-Top-2Perc {
  margin-top: 2%;
}
.margin-left-1point6Perc {
  margin-left: 2.8% !important;
}
.width2 {
  width: 95.2% !important;
}
.margin-left-1point6Perc {
  margin-left: 2.8% !important;
}
</style>


// WEBPACK FOOTER //
// src/pages/Reflection.vue